import { createContext, useContext } from 'react';

export const SortableRowHandleContext = createContext(null);

export const useSortableRowHandle = () => useContext(SortableRowHandleContext);
